import { useMutation } from '@tanstack/react-query'
import { createPaymentLimit } from 'services/PaymentLimitsService'

export const useCreatePaymentLimitMutation = () => {
  return useMutation({ mutationFn: createPaymentLimit })
}
